import { GtagEvent } from '@/app/ga';
import { Button } from '@/components/atoms/Button';
import { getCachedSession } from '@/features/auth/utils/sessionCache';
import { useMessage } from '@/shared/hooks/useMessage';
import { trackEvent } from '@/shared/utils/mixpanel';
import { useRouter } from 'next/navigation';
import { ReactNode, useState } from 'react';

interface DropdownItem {
  label: ReactNode;
  href: string;
  target?: string;
  gtagEvent: string;
  requiresAuth?: boolean;
}

interface NavDropdownButtonProps {
  label: string;
  items: DropdownItem[];
}

export const NavDropdownButton = ({ label, items }: NavDropdownButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const { showCustomMessage, showLoginRequired } = useMessage();

  return (
    <div
      className="relative"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <Button variant="ghost" size="lg" className="text-[#1D232B] font-bold! text-xl!">
        {label}
      </Button>

      {isOpen && (
        <div className="absolute top-full left-1.5 mt-0 p-0 bg-white rounded-lg shadow-lg border border-(--secondary-300) z-50 min-w-[156px] overflow-hidden">
          <div className="flex flex-col">
            {items.map((item, index) => (
              <div key={index} className="block cursor-pointer" onClick={async () => {
                if (item.href === '/offer-calculator') {
                  trackEvent('Button Click', { 'Page Name': '홈 화면', 'Button Name': '오퍼가' });
                }
                if (item.href === '/warehouses') {
                  trackEvent('Button Click', { 'Page Name': '홈 화면', 'Button Name': '지도' });
                }

                if (item.href === '/coming-soon') {
                  showCustomMessage('더 나은 서비스를 위해 준비 중입니다.', '준비 중');
                  return false;
                }

                // 로그인이 필요한 경우에만 세션 체크
                if (item.requiresAuth) {
                  const session = await getCachedSession();
                  if (!session) {
                    showLoginRequired(() => {
                      router.push('/signin');
                    });
                    return false;
                  }
                }

                if (item.gtagEvent) {
                  GtagEvent(item.gtagEvent, {
                    'tab_name': item.label,
                  });
                }

                if (item.target === '_blank') {
                  window.open(item.href, '_blank');
                } else {
                  router.push(item.href);
                }
              }}>
                <div className="p-0 hover:bg-(--secondary-50) rounded body-16r py-2.5 px-3 text-(--secondary-800)">
                  {item.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      )
      }
    </div >
  );
};
